// @flow
import * as React from "react";
import { Field } from "formik";
import { SelectField } from "../../../components/DynamicForm/Elements/SelectField";

export const getAutoCompleteControl = (props: any) => {
  const autoCompleteProps = { ...props, isSearchable: true };
  return <Field component={SelectField} {...autoCompleteProps} />;
};
